import React from "react";
import { Block, NoteRow } from "../../blockModel/types";
import { RenderCtx, es, editableProps, contentProps } from "../renderText";

export function renderNotes(block: Block, ctx: RenderCtx): JSX.Element {
	const id = block.id ?? "";
	const s = block.style ?? {};
	const color = s.color ?? "info";
	const { radius } = ctx.theme;
	// Element style key stays ":ntitle" for inspector styling.
	// data-f must be "title" so writeBack routes it to setBlockData({title}).
	const titleKey = id + ":ntitle";

	let body: JSX.Element;
	const editable = !!ctx.editable;
	if (s.layout === "rows" && block.data.rows) {
		const rows = block.data.rows as NoteRow[];
		body = (
			<>
				{rows.map((row, i) => {
					const nkKey = id + ":nk:" + i;
					const nvKey = id + ":nv:" + i;
					return (
						<div
							key={i}
							className="e-noterow"
							data-row={id + ":" + i}>
							<b
								style={es(ctx.elStyle, nkKey)}
								{...(editable ? editableProps(nkKey, "nk:" + i) : {})}
								{...contentProps(row.k ?? "", ctx)}
							/>
							<span
								style={es(ctx.elStyle, nvKey)}
								{...(editable ? editableProps(nvKey, "nv:" + i) : {})}
								{...contentProps(row.v ?? "", ctx)}
							/>
						</div>
					);
				})}
			</>
		);
	} else {
		const items = block.data.items ?? [];
		body = (
			<ul>
				{items.map((item, i) => {
					const nliKey = id + ":nli:" + i;
					return (
						<li
							key={i}
							data-row={id + ":" + i}>
							<span
								style={es(ctx.elStyle, nliKey)}
								{...(editable ? editableProps(nliKey, "nli:" + i) : {})}
								{...contentProps(item, ctx)}
							/>
						</li>
					);
				})}
			</ul>
		);
	}

	return (
		<div
			className="e-body"
			style={{ paddingTop: 8, paddingBottom: 8 }}>
			<div
				className={"e-notes " + color}
				style={{ borderRadius: radius }}>
				<h4
					style={es(ctx.elStyle, titleKey)}
					{...(editable ? editableProps(titleKey, "title") : {})}
					{...contentProps(block.data.title ?? "", ctx)}
				/>
				{body}
			</div>
		</div>
	);
}
